<div class="flex flex-col items-center justify-center py-16 gap-4 text-center">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    class="w-12 h-12 text-gray-300"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M20 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"
    />
  </svg>

  <ng-container *ngIf="state === 'no-company'">
    <p class="text-sm font-bold text-chathams-blue">Selecione uma empresa para começar</p>
    <small class="text-xs text-chathams-blue">
      Escolha uma empresa no seletor acima para ver ou gerenciar o catálogo de produtos.
    </small>
  </ng-container>

  <ng-container *ngIf="state === 'no-catalog'">
    <p class="text-sm font-bold text-chathams-blue">Esta empresa ainda não tem catálogo</p>
    <small class="text-xs text-chathams-blue">
      Importe um arquivo CSV ou adicione produtos manualmente para começar.
    </small>
    <div class="flex gap-2 mt-2">
      <button type="button" class="h-9 px-4 btn btn--primary" (click)="importClicked.emit()">Importar arquivo</button>
      <button type="button" class="h-9 px-4 btn btn--secondary" (click)="manualClicked.emit()">
        Adicionar manualmente
      </button>
    </div>
  </ng-container>
</div>
